import AWSAppSyncClient from 'aws-appsync';
import React, { createContext, useContext } from 'react';

const LandingPageAppSyncContext = createContext<AWSAppSyncClient<any> | null>(null);

interface LandingPageAppSyncProviderProps {
  children: React.ReactNode;
  client: AWSAppSyncClient<any>;
}

export const LandingPageAppSyncProvider = ({ children, client }: LandingPageAppSyncProviderProps) => {
  return (
    <LandingPageAppSyncContext.Provider value={client}>
      {children}
    </LandingPageAppSyncContext.Provider>
  );
};

export const useLandingPageAppSync = () => {
  const context = useContext(LandingPageAppSyncContext);
  if (!context) {
    throw new Error('useLandingPageAppSync must be used within a LandingPageAppSyncProvider');
  }
  return context;
};